import { isFieldFilterValid } from 'module/types/filter-field/grouped-filter/utils';
//import { Button } from 'module/ui/components/atoms/button';
import { Dropdown } from 'module/ui/components/atoms/dropdown/dropdown';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faSave, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@rocketlane/ui';
import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FilterBox } from './filter-box';
import { BaseGroupedFilterComponentProps } from '../../types';
import { BaseFilterPopover } from '../base-filter-popover/popover';

const FilterButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export interface Props extends BaseGroupedFilterComponentProps {
  loading: boolean;
  reset: () => void;
  onVisibilityChange?: (visible: boolean) => void;
  onDone?: () => void;
  onSaveView?: () => void;
  onUpdateView?: () => void;
  isViewSelected?: boolean;
  filtersChanged: boolean;
  showSaveView?: boolean;
}

export const GroupedFilterPopover: FC<React.PropsWithChildren<Props>> = ({
  loading,
  filter,
  fields,
  onChange,
  onVisibilityChange,
  reset,
  getSelectEditorComponents,
  getFilterOperationTypeOptions,
  getOperationOptionRenderer,
  userOptionsGetter,
  onDone,
  onSaveView,
  onUpdateView,
  isViewSelected,
  filtersChanged,
  showSaveView = true,
}) => {
  const validCriteriaCount = useMemo(
    () =>
      filter?.groupCriteria?.filter(
        ({ criteria, hidden }) => isFieldFilterValid(criteria) && !hidden,
      ).length,
    [filter?.groupCriteria],
  );

  const saveMenuItems = [
    {
      key: 'update',
      icon: <FontAwesomeIcon icon={faSave} />,
      label: 'Update view',
      onClick: onUpdateView,
      disabled: !isViewSelected,
    },
    {
      key: 'save',
      icon: <FontAwesomeIcon icon={faPlus} />,
      label: 'Save as new view',
      onClick: onSaveView,
    },
  ];

  const showDropdown = showSaveView && isViewSelected && filtersChanged;

  const filterButtonContent = (
    <FilterButtonWrapper>
      <FormattedMessage
        id="captions.buttons.filter"
        values={{
          count: validCriteriaCount,
        }}
      />
    </FilterButtonWrapper>
  );

  const saveViewLabel = () => {
    if (validCriteriaCount > 0) {
      return (
        <FilterButtonWrapper>
          <Dropdown
            menu={{
              items: showDropdown ? saveMenuItems : [saveMenuItems[1]],
              onClick: (info) => {
                info.domEvent.stopPropagation();
              },
            }}
            trigger={['click']}
          >
            <span
              onClick={(e) => e.stopPropagation()}
              style={{
                display: 'inline-flex',
                borderLeft: '1px solid rgba(0, 0, 0, 0.1)',
                marginLeft: '8px',
                paddingLeft: '4px',
              }}
            >
              <Button
                variant="ghost"
                size="small"
                leftIcon={<FontAwesomeIcon icon={faSave} />}
              />
            </span>
          </Dropdown>
        </FilterButtonWrapper>
      );
    }

    return <></>;
  };

  return (
    <BaseFilterPopover
      loading={loading}
      popoverTriggerLabel={filterButtonContent}
      saveViewLabel={showSaveView ? saveViewLabel() : undefined}
      onDone={onDone}
      onVisibilityChange={onVisibilityChange}
      reset={reset}
      showClearButton={validCriteriaCount > 0}
      popoverContent={
        <FilterBox
          fields={fields}
          filter={filter}
          onChange={onChange}
          getFilterOperationTypeOptions={getFilterOperationTypeOptions}
          getSelectEditorComponents={getSelectEditorComponents}
          getOperationOptionRenderer={getOperationOptionRenderer}
          userOptionsGetter={userOptionsGetter}
        />
      }
    />
  );
};
